import React, { Component, Fragment } from "react";
import _ from "lodash";
import { Button } from "reactstrap";
import Dialog from "../../libraries/Dialog";
import ToggleButton from "../../libraries/ToggleButton";
import { ButtonCirclePlus } from "components/Common/Buttons";
import { plus } from "react-icons-kit/icomoon/plus";
import { languageService } from "../../Language/language.service";
import ThisTable from "components/Common/ThisTable/index";
import StockVoucher from "./StockVoucher/StockVoucher";
import { getLoggedInUser } from "../MainPage/UserInfo";
import { ButtonStyle } from "style/basic/commonControls";
import { themeService } from "../../theme/service/activeTheme.service";

const ViewEditToggleButtonValues = ["View", "Edit"];
const [ViewItem, EditItem] = ViewEditToggleButtonValues;
const Reasons = [
  {
    name: "Adjustment +",
    operation: "+",
  },
  {
    name: "Adjustment -",
    operation: "-",
  },
  {
    name: "Stock Movement",
    operation: "Stock Movement",
  },
  {
    name: "Purchase Order",
    operation: "Purchase Order",
  },
];
const DocTypes = ["Load Transfer", "Receipt", "Issue", "Adjustment", "Return", "Sales Order", "Inventory Count"];

const MockData = {
  materialList: [
    { id: "RT001", desc: "Railroad Tracks", linear: { unit: "ft" } },
    { id: "TIE002", desc: "Railroad Ties", linear: undefined },
    { id: "SPK003", desc: "Rail Spikes", linear: undefined },
    { id: "BAL004", desc: "Track Ballast", linear: undefined },
    { id: "SWT005", desc: "Track Switches", linear: undefined },
    { id: "SGL006", desc: "Signal Lights", linear: undefined },
    { id: "WCT007", desc: "Wooden Crossties", linear: undefined },
    { id: "FPL008", desc: "Fishplates", linear: undefined },
    { id: "INS009", desc: "Rail Insulators", linear: undefined },
    { id: "BLT010", desc: "Track Bolts", linear: undefined },
    { id: "RCL011", desc: "Rail Clamps", linear: undefined },
    { id: "GRD012", desc: "Guard Rails", linear: { unit: "ft" } },
    { id: "SLR013", desc: "Rail Sleepers", linear: undefined },
    { id: "JBR014", desc: "Joint Bars", linear: undefined },
    { id: "RPN015", desc: "Rail Pins", linear: undefined },
    { id: "CRO016", desc: "Railroad Crossings", linear: undefined },
    { id: "BMP017", desc: "Bumper Posts", linear: undefined },
    { id: "TRN018", desc: "Turnouts", linear: undefined },
    { id: "GRS019", desc: "Grease Fittings", linear: undefined },
    { id: "WHL020", desc: "Wheel Stops", linear: undefined },
    { id: "SND021", desc: "Track Sanders", linear: undefined },
    { id: "GGE022", desc: "Track Gauges", linear: undefined },
    { id: "ANT023", desc: "Rail Anchors", linear: undefined },
    { id: "CUL024", desc: "Culverts", linear: undefined },
    { id: "BRG025", desc: "Bridge Timbers", linear: undefined },
    { id: "SGN026", desc: "Railway Signs", linear: undefined },
    { id: "CAT027", desc: "Catenary Wire", linear: { unit: "ft" } },
    { id: "DER028", desc: "Derails", linear: undefined },
    { id: "LUB029", desc: "Rail Lubricators", linear: undefined },
    { id: "FNC030", desc: "Fencing Materials", linear: { unit: "ft" } },
  ],
  Data: {
    "warehouse asset1": [
      { materialId: "RT001", unitId: "RT001-L-100", desc: "Railroad Tracks", qty: 10, batchNo: "Batch001" },
      { materialId: "RT001", unitId: "RT001-L-15", desc: "Railroad Tracks 101", qty: 3, batchNo: "Batch101" },
      { materialId: "RT001", unitId: "RT001-L-5", desc: "Railroad Tracks 101", qty: 5, batchNo: "Batch101" },
      { materialId: "TIE002", unitId: "TIE002-D", desc: "Railroad Ties", qty: 5000, batchNo: "Batch002" },
      { materialId: "SPK003", unitId: "SPK003-D", desc: "Rail Spikes", qty: 50000, batchNo: "Batch003" },
      { materialId: "BAL004", unitId: "BAL004-D", desc: "Track Ballast", qty: 10000, batchNo: "Batch004" },
      { materialId: "SWT005", unitId: "SWT005-D", desc: "Track Switches", qty: 50, batchNo: "Batch005" },
      { materialId: "SGL006", unitId: "SGL006-D", desc: "Signal Lights", qty: 200, batchNo: "Batch006" },
      { materialId: "WCT007", unitId: "WCT007-D", desc: "Wooden Crossties", qty: 7500, batchNo: "Batch007" },
    ],
    "warehouse asset2": [
      { materialId: "RCL011", unitId: "RCL011-D", desc: "Rail Clamps", qty: 3000, batchNo: "Batch011" },
      { materialId: "GRD012", unitId: "GRD012-L-51", desc: "Guard Rails", qty: 500, batchNo: "Batch012" },
      { materialId: "SLR013", unitId: "SLR013-D", desc: "Rail Sleepers", qty: 6000, batchNo: "Batch013" },
      { materialId: "JBR014", unitId: "JBR014-D", desc: "Joint Bars", qty: 4000, batchNo: "Batch014" },
      { materialId: "RPN015", unitId: "RPN015-D", desc: "Rail Pins", qty: 30000, batchNo: "Batch015" },
      { materialId: "CRO016", unitId: "CRO016-D", desc: "Railroad Crossings", qty: 100, batchNo: "Batch016" },
      { materialId: "BMP017", unitId: "BMP017-D", desc: "Bumper Posts", qty: 150, batchNo: "Batch017" },
      { materialId: "TRN018", unitId: "TRN018-D", desc: "Turnouts", qty: 75, batchNo: "Batch018" },
      { materialId: "GRS019", unitId: "GRS019-D", desc: "Grease Fittings", qty: 5000, batchNo: "Batch019" },
      { materialId: "WHL020", unitId: "WHL020-D", desc: "Wheel Stops", qty: 200, batchNo: "Batch020" },
    ],
    "warehouse asset3": [
      { materialId: "BRG025", unitId: "BRG025-D", desc: "Bridge Timbers", qty: 1000, batchNo: "Batch025" },
      { materialId: "SGN026", unitId: "SGN026-D", desc: "Railway Signs", qty: 800, batchNo: "Batch026" },
      { materialId: "CAT027", unitId: "CAT027-L-50", desc: "Catenary Wire", qty: 5000, batchNo: "Batch027" },
      { materialId: "DER028", unitId: "DER028-D", desc: "Derails", qty: 100, batchNo: "Batch028" },
      { materialId: "LUB029", unitId: "LUB029-D", desc: "Rail Lubricators", qty: 400, batchNo: "Batch029" },
      { materialId: "FNC030", unitId: "FNC030-L-10", desc: "Fencing Materials", qty: 10000, batchNo: "Batch030" },
    ],
    default: [
      { materialId: "BAL004", unitId: "BAL004-D", desc: "Track Ballast", qty: 10000, batchNo: "Batch004" },
      { materialId: "SWT005", unitId: "SWT005-D", desc: "Track Switches", qty: 50, batchNo: "Batch005" },
      { materialId: "SGL006", unitId: "SGL006-D", desc: "Signal Lights", qty: 200, batchNo: "Batch006" },
      { materialId: "WCT007", unitId: "WCT007-D", desc: "Wooden Crossties", qty: 7500, batchNo: "Batch007" },
      { materialId: "FPL008", unitId: "FPL008-D", desc: "Fishplates", qty: 2000, batchNo: "Batch008" },
    ],
  },
};

class StockView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      materialList: MockData.materialList,
      selectedAsset: _.cloneDeep(props.selectedAsset),
      stockData: MockData.Data.default,
      stockData: [],
      editMode: false,
      showVoucher: false,
      page: 0,
      pageSize: 10,
      filterText: "",
      selectedOption: "Unit ID",
    };

    this.closeDialog = this.closeDialog.bind(this);
    this.handleShowStockVoucher = this.handleShowStockVoucher.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleOptionSelected = this.handleOptionSelected.bind(this);
    this.handleVoucherSubmit = this.handleVoucherSubmit.bind(this);
  }

  handleVoucherSubmit(list) {
    let STData = _.cloneDeep(this.state.stockData);
    let updatedData = this.updateStock(STData, list);

    this.setState({ stockData: updatedData, showVoucher: false, editMode: false });
  }
  updateStock = (y, x) => {
    const yMap = new Map(y.map((item) => [item.unitId, item]));

    x.forEach((item) => {
      if (yMap.has(item.unitId)) {
        Object.assign(yMap.get(item.unitId), item);
      } else {
        y.push(item);
      }
    });

    return Array.from(yMap.values()).concat(y.filter((item) => !yMap.has(item.unitId)));
  };
  closeDialog() {
    this.props.openStockView(false);
  }

  handleShowStockVoucher() {
    this.setState({ showVoucher: true });
  }

  StockVoucherActions = (action) => {
    if (action === "cancel") {
      this.setState({ showVoucher: false });
    }
  };

  handlePageChange(page) {
    this.setState({ page });
  }

  handleFilterChange(e) {
    this.setState({ filterText: e.target.value });
  }

  handleOptionSelected(option) {
    this.setState({ selectedOption: option });
  }

  componentDidUpdate(prevProps, prevState) {
    const { filterText, selectedOption, selectedAsset } = this.state;

    if (
      filterText !== prevState.filterText ||
      selectedOption !== prevState.selectedOption
      //  || this.props.stock !== prevProps.stock
    ) {
      const mapAccessor = {
        "Unit ID": "unitId",
        "Material ID": "materialId",
        Name: "desc",
      };
      let MyData = MockData.Data[selectedAsset.unitId] || MockData.Data.default;
      const filteredData = MyData.filter((item) => item[mapAccessor[selectedOption]].toLowerCase().includes(filterText.toLowerCase()));

      this.setState({
        stockData: filteredData,
        page: 0,
      });
    }
  }
  componentDidMount() {
    const { selectedAsset } = this.state;
    if (selectedAsset) {
      let MyData = MockData.Data[selectedAsset.unitId] || MockData.Data.default;

      this.setState({
        stockData: MyData,
        page: 0,
      });
    }
  }

  render() {
    const { selectedAsset, editMode, showVoucher, stockData, page, pageSize, filterText, selectedOption, materialList } = this.state;
    const currentDate = new Date();
    const currUser = getLoggedInUser();

    return (
      <Dialog
        className={"manage-equipments-dialog"}
        title={languageService("Manage Stock")}
        isOpen={true}
        body={
          <Fragment>
            <ToggleButton
              options={ViewEditToggleButtonValues}
              value={editMode ? EditItem : ViewItem}
              onSelected={() => this.setState({ editMode: !editMode })}
            />
            {!editMode ? (
              <Fragment>
                <p>
                  <strong>Showing Stock of {selectedAsset.unitId || "Warehouse"}</strong>
                </p>
                <div style={{ display: "flex", flexDirection: "column", marginBlock: "10px" }}>
                  <div>
                    <strong>Filter by</strong>
                    <ToggleButton
                      options={["Unit ID", "Material ID", "Name"]}
                      onSelected={this.handleOptionSelected}
                      value={selectedOption}
                    />
                  </div>
                  <div>
                    <input type="text" placeholder="Filter..." value={filterText} onChange={this.handleFilterChange} />
                  </div>
                </div>
                <ThisTable
                  tableColumns={[
                    { Header: "Material ID", accessor: "materialId" },
                    { Header: "Unit ID", accessor: "unitId" },
                    { Header: "Name", accessor: "desc" },
                    { Header: "Quantity", accessor: "qty" },
                  ]}
                  tableData={stockData}
                  minRows={10}
                  pagination={true}
                  pageSize={pageSize}
                  page={page}
                  handlePageChange={this.handlePageChange}
                />
              </Fragment>
            ) : (
              <Fragment>
                <p>
                  <strong>Create a Voucher</strong>
                </p>
                {showVoucher && (
                  <StockVoucher
                    Actions={this.StockVoucherActions}
                    StockData={stockData}
                    wareHouse={selectedAsset.unitId || ""}
                    Date={currentDate.toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })}
                    User={currUser}
                    ReasonsAndOperations={Reasons}
                    DocTypes={DocTypes}
                    SubmitVoucher={this.handleVoucherSubmit}
                    materialList={materialList}
                  />
                )}
                <ButtonCirclePlus
                  iconSize={30}
                  icon={plus}
                  customClassName={"road"}
                  backgroundColor="#e3e9ef"
                  margin="5px 0px 0px 0px"
                  borderRadius="50%"
                  hoverBackgroundColor="#e3e2ef"
                  hoverBorder="0px"
                  activeBorder="3px solid #e3e2ef "
                  iconStyle={{
                    color: "#c4d4e4",
                    background: "var(--fifth)",
                    borderRadius: "50%",
                    border: "3px solid ",
                  }}
                  handleClick={this.handleShowStockVoucher}
                />
              </Fragment>
            )}
          </Fragment>
        }
        footer={
          <Fragment>
            <Button style={themeService(ButtonStyle.commonButton)} onClick={this.closeDialog}>
              {languageService("Update")}
            </Button>
            <Button onClick={this.closeDialog} style={themeService(ButtonStyle.commonButton)}>
              {languageService("Cancel")}
            </Button>
          </Fragment>
        }
        closeDialog={this.closeDialog}
      />
    );
  }
}

export default StockView;



// WEBPACK FOOTER //
// ./src/components/StockView/index.jsx